// Site-wide "Areas We Serve" navigation.
// Deliberate MARKET-PRIORITY order (not alphabetical): highest-value service
// areas first. Every entry must point at a city page that actually exists.
export type ServiceAreaNavItem = { name: string; url: string };

export const serviceAreaNav: ServiceAreaNavItem[] = [
  { name: "Toronto", url: "/" },
  { name: "Oakville", url: "/gta/oakville" },
  { name: "King City", url: "/gta/king-city" },
  { name: "Kleinburg", url: "/gta/kleinburg" },
  { name: "Vaughan", url: "/gta/vaughan" },
  { name: "Richmond Hill", url: "/gta/richmond-hill" },
  { name: "Thornhill", url: "/gta/thornhill" },
  { name: "Markham", url: "/gta/markham" },
  { name: "Aurora", url: "/gta/aurora" },
  { name: "Woodbridge", url: "/gta/woodbridge" },
  { name: "Maple", url: "/gta/maple" },
  { name: "Caledon", url: "/gta/caledon" },
  { name: "Bolton", url: "/gta/bolton" },
  { name: "Burlington", url: "/gta/burlington" },
  { name: "Milton", url: "/gta/milton" },
  { name: "Georgetown", url: "/gta/georgetown" },
  { name: "Newmarket", url: "/gta/newmarket" },
  { name: "Etobicoke", url: "/gta/etobicoke" },
  { name: "North York", url: "/gta/north-york" },
  { name: "Mississauga", url: "/gta/mississauga" },
  { name: "East York", url: "/gta/east-york" },
  { name: "Scarborough", url: "/gta/scarborough" },
  { name: "Brampton", url: "/gta/brampton" },
  { name: "Pickering", url: "/gta/pickering" },
  { name: "Whitby", url: "/gta/whitby" },
  { name: "Ajax", url: "/gta/ajax" },
  { name: "Oshawa", url: "/gta/oshawa" },
];

// Column split for the desktop mega-dropdown: priority is read
// top-left → down, then top-right → down.
export const serviceAreaNavColumns: ServiceAreaNavItem[][] = [
  serviceAreaNav.slice(0, 14),
  serviceAreaNav.slice(14),
];

// Toronto neighbourhood pages — used for crawlable homepage links so every
// neighbourhood page is reachable in one click from the strongest page.
export const torontoNeighbourhoodNav: ServiceAreaNavItem[] = [
  { name: "Downtown Toronto", url: "/toronto/downtown-toronto" },
  { name: "Midtown Toronto", url: "/toronto/midtown-toronto" },
  { name: "Yorkville", url: "/toronto/yorkville" },
  { name: "Rosedale", url: "/toronto/rosedale" },
  { name: "Forest Hill", url: "/toronto/forest-hill" },
  { name: "The Annex", url: "/toronto/the-annex" },
  { name: "King West", url: "/toronto/king-west" },
  { name: "Liberty Village", url: "/toronto/liberty-village" },
  { name: "Corktown", url: "/toronto/corktown" },
  { name: "Little Italy", url: "/toronto/little-italy" },
  { name: "Kensington Market", url: "/toronto/kensington-market" },
  { name: "Riverdale", url: "/toronto/riverdale" },
  { name: "Leslieville", url: "/toronto/leslieville" },
  { name: "The Danforth", url: "/toronto/the-danforth" },
  { name: "The Beaches", url: "/toronto/the-beaches" },
  { name: "High Park", url: "/toronto/high-park" },
  { name: "Bloor West", url: "/toronto/bloor-west" },
  { name: "Junction Triangle", url: "/toronto/junction-triangle" },
];
